
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { HomeIcon, ArrowLeft, HelpCircle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-purple-50 to-white px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <img 
          src="https://images.unsplash.com/photo-1581090464777-f3220bbe1b8b" 
          alt="Nicolas Cage 404" 
          className="mx-auto mb-6 w-64 h-64 object-cover rounded-full shadow-lg"
        />
        <div className="space-y-2">
          <h1 className="text-8xl font-bold text-purple-600">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700">Page Not Found</h2>
          <p className="text-gray-500 mt-4">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent my-8" />
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button asChild variant="default" className="w-full sm:w-auto">
            <Link to="/" className="inline-flex items-center gap-2">
              <HomeIcon className="h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <Button asChild variant="outline" className="w-full sm:w-auto">
            <Link to="/browse" className="inline-flex items-center gap-2">
              <ArrowLeft className="h-4 w-4" />
              Browse Agents
            </Link>
          </Button>
          <Button asChild variant="ghost" className="w-full sm:w-auto">
            <a href="https://docs.lovable.dev" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2">
              <HelpCircle className="h-4 w-4" />
              Help Center
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
